(() => {
  if (window.mysentiaOverridesLoaded) return;
  window.mysentiaOverridesLoaded = true;

  const collapseCollectionFilters = () => {
    if (!document.body.classList.contains('template-collection')) return;
    const container = document.querySelector('.filter-container');
    if (container) container.classList.remove('filter-container--show-filters-desktop');
    document.querySelectorAll('[data-toggle-filters].toggle-btn').forEach((button) => button.classList.remove('toggle-btn--revealed-desktop'));
  };
  document.addEventListener('DOMContentLoaded', collapseCollectionFilters);
  window.addEventListener('pageshow', collapseCollectionFilters);

  const visibleTermsCheckbox = () => Array.from(document.querySelectorAll('terms-agreement input[type="checkbox"]'))
    .find((input) => {
      const agreement = input.closest('terms-agreement');
      if (!agreement || agreement.getClientRects().length === 0) return false;
      const style = window.getComputedStyle(agreement);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });

  const clearTermsError = (checkbox) => {
    if (!checkbox) return;
    checkbox.removeAttribute('aria-invalid');
    const errorId = checkbox.getAttribute('aria-describedby');
    const error = errorId ? document.getElementById(errorId) : null;
    if (error) error.hidden = true;
  };

  const validateTerms = () => {
    const checkbox = visibleTermsCheckbox();
    if (!checkbox || checkbox.checked) {
      clearTermsError(checkbox);
      return true;
    }

    checkbox.setAttribute('aria-invalid', 'true');
    const errorId = checkbox.getAttribute('aria-describedby');
    const error = errorId ? document.getElementById(errorId) : null;
    if (error) error.hidden = false;
    checkbox.focus({ preventScroll: false });
    return false;
  };

  window.mysentiaValidateTerms = validateTerms;

  window.addEventListener('click', (event) => {
    if (!event.target.closest('.mysentia-proceed-button')) return;
    if (validateTerms()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter?.matches?.('.mysentia-proceed-button, [name="checkout"]')) return;
    if (validateTerms()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('terms-agreement input[type="checkbox"]')) return;
    if (event.target.checked) clearTermsError(event.target);
  });

})();


